import { render, staticRenderFns } from "./WebsiteLicenses.vue?vue&type=template&id=a343770c&scoped=true&"
import script from "./WebsiteLicenses.vue?vue&type=script&lang=js&"
export * from "./WebsiteLicenses.vue?vue&type=script&lang=js&"
import style0 from "../OrgDefinitionsChildrens.css?vue&type=style&index=0&id=a343770c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a343770c",
  null
  
)

export default component.exports